module.exports = __webpack_public_path__ + "images/emoji/person_with_blond_hair.d6582b47681e1b8293b9.png";